import TiffWrapUp2023 from './TiffWrapUp2023';
export default TiffWrapUp2023;
